export const accessEventsConstants = {
    GETALL_ACCESS_EVENTS_REQUEST: "GETALL_ACCESS_EVENTS_REQUEST",
    GETALL_ACCESS_EVENTS_SUCCESS: "GETALL_ACCESS_EVENTS_SUCCESS",
    GETALL_ACCESS_EVENTS_FAILURE: "GETALL_ACCESS_EVENTS_FAILURE",

    GET_ACCESS_EVENTS_TOP_CARDS_REQUEST: "GET_ACCESS_EVENTS_TOP_CARDS_REQUEST",
    GET_ACCESS_EVENTS_TOP_CARDS_SUCCESS: "GET_ACCESS_EVENTS_TOP_CARDS_SUCCESS",
    GET_ACCESS_EVENTS_TOP_CARDS_FAILURE: "GET_ACCESS_EVENTS_TOP_CARDS_FAILURE",

    GET_EVENT_ACCESS_STATUS_REQUEST: "GET_EVENT_ACCESS_STATUS_REQUEST",
    GET_EVENT_ACCESS_STATUS_SUCCESS: "GET_EVENT_ACCESS_STATUS_SUCCESS",
    GET_EVENT_ACCESS_STATUS_FAILURE: "GET_EVENT_ACCESS_STATUS_FAILURE",

    GET_EVENT_ACCESS_FILTERS_REQUEST: "GET_EVENT_ACCESS_FILTERS_REQUEST",
    GET_EVENT_ACCESS_FILTERS_SUCCESS: "GET_EVENT_ACCESS_FILTERS_SUCCESS",
    GET_EVENT_ACCESS_FILTERS_FAILURE: "GET_EVENT_ACCESS_FILTERS_FAILURE",
};